import React from 'react';

export interface TableContextValue {
    variant: 'head' | 'body';
}

export const TableContext = React.createContext<TableContextValue>({variant: 'body'});
